/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconFlatHammer: {
  name: 'flat_hammer';
  data: string;
} = {
  name: 'flat_hammer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M371.267 119.202 371.268 119.203 371.268 119.202z"/><path d="m514.995 217.98-32.343 32.343-24.075-24.075c-8.035-8.038-20.297-8.685-34.516-4.561l-25.282-25.282 24.845-24.845-52.357-52.357-24.845 24.845-25.382-25.383c4.203-14.318 3.519-26.434-4.562-34.514l-172.7-50.088 40.301 182.487c9.002 9.003 20.849 10.557 34.502 6.943l24.198 24.198L25.716 464.755v104.713l269.421-269.421 24.098 24.098c-3.491 13.508-1.979 25.58 6.943 34.502l24.075 24.075L307.975 425l60.135 60.135 207.02-207.02-60.135-60.135z"/></svg>`,
};
